import React from 'react';
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';
import { Button } from './Button';
interface CTASectionProps {
  headline: string;
  body: string;
  buttonText: string;
  buttonLink: string;
  variant?: 'default' | 'dark';
}
export function CTASection({
  headline,
  body,
  buttonText,
  buttonLink,
  variant = 'default'
}: CTASectionProps) {
  const bgColor = variant === 'dark' ? 'bg-deep' : 'bg-surface';
  const textColor = variant === 'dark' ? 'text-white' : 'text-ink';
  const bodyColor = variant === 'dark' ? 'text-gray-300' : 'text-gray-600';
  return <motion.section initial={{
    opacity: 0,
    y: 20
  }} whileInView={{
    opacity: 1,
    y: 0
  }} viewport={{
    once: true
  }} transition={{
    duration: 0.6
  }} className={`${bgColor} rounded-2xl p-12 text-center`} data-id="element-17">
      <h2 className={`text-3xl md:text-4xl font-bold ${textColor} mb-4`} data-id="element-18">
        {headline}
      </h2>
      <p className={`text-lg ${bodyColor} max-w-2xl mx-auto mb-8`} data-id="element-19">{body}</p>
      <Link to={buttonLink} data-id="element-20">
        <Button variant={variant === 'dark' ? 'primary' : 'primary'} size="lg" data-id="element-21">
          {buttonText}
        </Button>
      </Link>
    </motion.section>;
}